import { useEffect } from "react";

const BaiduAnalytics = () => {
  useEffect(() => {
    if (window._hmt) return; // 避免重复加载

    window._hmt = window._hmt || [];
    const script = document.createElement("script");
    script.src = "https://hm.baidu.com/hm.js?b2fef3d7eea8980cdb92969c4599cd90";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return null; // 这个组件不渲染任何 UI
};

export default BaiduAnalytics;
